import React from 'react'

export default function Quicklinks() {
    return (
        <div>
            THis is quicklinks part of quick info
        </div>
    )
}
